/* RESPONSIBLE TEAM: team-actions */

import { ParentAction, ChildAction } from './action';

export interface TriggerableProcedure {
  id: number;
  name: string;
}

export default class TriggerProcedureAction extends ParentAction {
  id = 'trigger-procedure';
  icon = 'sub-procedures' as const;
  paneComponent = 'inbox2/command-k/trigger-procedure/pane';
  cacheLatest = true;

  buildResults(procedures: TriggerableProcedure[]): ChildAction[] {
    return procedures.map(
      (procedure) =>
        new ChildAction({
          parent: this,
          id: procedure.id.toString(),
          label: procedure.name,
          value: procedure,
        }),
    );
  }
}
